import { z } from 'zod';

import { TenantAttribute } from './tenant-attribute';

export type UpdateTenantAttributesPayload = z.infer<typeof updateTenantAttributesPayloadSchema>;

export const updateTenantAttributesPayloadSchema = z.object({
  attributes: z.array(z.enum(TenantAttribute)),
});
